import React from 'react';
import styled from 'styled-components';

import SearchInputIcon from '../../../../../Icons/SearchInputIcon';

const QuestionBlock = () => (
  <QuestionBlockWrapDiv>
    <FirstBlockLoaderWrapDiv></FirstBlockLoaderWrapDiv>

    <SearchBlockWrapperDiv>
      <TextBoxWrapperDiv>
        <TextBoxContentDiv>
          <TextBox />
          <SearchWrap />
        </TextBoxContentDiv>
      </TextBoxWrapperDiv>
      <AskQuestionWrapperDiv>
        <AskQuestionWrapSpan></AskQuestionWrapSpan>
      </AskQuestionWrapperDiv>
    </SearchBlockWrapperDiv>

    <QuestionAskWrapDiv>
      <QuestionAskWrapSpan></QuestionAskWrapSpan>
    </QuestionAskWrapDiv>
  </QuestionBlockWrapDiv>
);

export default QuestionBlock;

const QuestionBlockWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  padding:${props.theme.spacing.large};
  border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
  width:100%;


`,
);

const FirstBlockLoaderWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:17.5rem;
  height:2.5rem;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};


`,
);

const SearchBlockWrapperDiv = styled.div(
  props => `
  padding-top: ${props.theme.spacing.base};
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  widht:100%;
`,
);

const TextBoxWrapperDiv = styled.div(
  props => `
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding-right: ${props.theme.spacing.base};
  width: 80%;
`,
);

const TextBoxContentDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  position: relative;
  width: 100%;
`;

const QuestionNotFoundSpan = styled.span(
  props => `
  color: ${props.theme.colors.goBrandBlue.base};
  padding-bottom: ${props.theme.spacing.small};
  font-size: ${props.theme.font.custom(14)};
`,
);

const AskQuestionWrapperDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  width: 20%;
`;

const AskQuestionWrapSpan = styled.span(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:100%;
  height:4.2rem;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
`,
);

const AskQuestionTextWrapper = styled.span(
  props => `
  font-weight: bold;
  font-size: ${props.theme.font.custom(16)};
  color: ${props.theme.colors.downriver.medium};
  padding-left: ${props.theme.spacing.xlarge};
`,
);

const TextBox = styled.input.attrs({type: 'text'})(
  props => `
  display: block;
  width: 100%;
  height: 4.2rem;
  padding: ${props.theme.spacing.base} ${props.theme.spacing.base} ${props.theme.spacing.base} 3rem;
  line-height: 1.3;
  border-radius: ${props.theme.misc.borderRadius.base};
  flex-direction: row;
  align-items: center;
  justify-conent: center;
  font-family: ${props.theme.font.fontFamily};
  font-size: ${props.theme.font.custom(14)};
  color: ${props.theme.colors.downriver.medium};
  background-color: ${props.theme.colors.goWhite.base};
  border: ${props.theme.misc.border.base} solid ${props.theme.colors.goBrandBlue.base};


  &::-webkit-input-placeholder {
    opacity: 0.5;
    ${TextBox}.font-size;
    ${TextBox}.font-family;
    ${TextBox}.font-weight;
  }
  &:focus {
    border: ${props.theme.misc.border.base} solid ${props.theme.colors.goBrandBlue.base}
    box-shadow: none;
    outline: none;
  }
`,
);

const SearchWrap = styled(SearchInputIcon)(
  props => `
      width:1.7rem;
      height:1.7rem;
      fill:grey;
      position:absolute;
      top:1.2rem;
      left:1.5rem;
      margin-right:0;

  `,
);

const QuestionAskWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction:row;
  width:100%;
  padding-top:${props.theme.spacing.base};

`,
);

const QuestionAskWrapSpan = styled.span(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:14.5rem;
  height:2.5rem;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};


`,
);
